var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mt-10" }, [
    _c(
      "div",
      { staticClass: "bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6" },
      [
        _c("div", { staticClass: "md:grid md:grid-cols-3 md:gap-6" }, [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "md:col-span-2" },
            [
              _vm.config.officeHours.isEnabled
                ? _c("Alert", {
                    attrs: { type: "warning", text: _vm.alertText }
                  })
                : _vm._e(),
              _c("fieldset", { staticClass: "mt-6" }, [
                _c(
                  "legend",
                  {
                    staticClass: "text-base leading-6 font-medium text-gray-900"
                  },
                  [_vm._v(" Enable office hours ")]
                ),
                _c(
                  "div",
                  { staticClass: "mt-4 flex flex-wrap" },
                  [
                    _c("VSwitch", {
                      model: {
                        value: _vm.config.officeHours.isEnabled,
                        callback: function($$v) {
                          _vm.$set(_vm.config.officeHours, "isEnabled", $$v)
                        },
                        expression: "config.officeHours.isEnabled"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm.config.officeHours.isEnabled
                ? _c("div", { staticClass: "mt-4" }, [
                    _c("fieldset", { staticClass: "mt-6 mb-4" }, [
                      _c(
                        "legend",
                        {
                          staticClass:
                            "text-base leading-6 font-medium text-gray-900"
                        },
                        [_vm._v(" Time zone ")]
                      ),
                      _c("div", { staticClass: "mt-4 flex flex-wrap" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.config.officeHours.timezone,
                                expression: "config.officeHours.timezone"
                              }
                            ],
                            staticClass:
                              "mt-1 block  py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm",
                            staticStyle: { color: "#22292f" },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.config.officeHours,
                                  "timezone",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          _vm._l(_vm.timezoneOptions, function(option, index) {
                            return _c(
                              "option",
                              { key: index, domProps: { value: option.value } },
                              [_vm._v(" " + _vm._s(option.text) + " ")]
                            )
                          }),
                          0
                        )
                      ])
                    ]),
                    _c("label", {}, [_vm._v("Hours")]),
                    _c("table", { staticClass: "w-full" }, [
                      _c(
                        "tbody",
                        _vm._l(_vm.officeHours, function(officeHour, index) {
                          return _c("tr", { key: index }, [
                            _c(
                              "td",
                              {
                                staticClass: "text-gray-700 text-sm",
                                attrs: { "data-qa": "selected_day" }
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.dayTitle[index + 1]) + " "
                                )
                              ]
                            ),
                            _c("td", { staticClass: "flex items-center" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: officeHour.officeHoursOpen,
                                      expression: "officeHour.officeHoursOpen"
                                    }
                                  ],
                                  staticClass:
                                    "mt-1 block  py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm",
                                  staticStyle: { color: "#22292f" },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        officeHour,
                                        "officeHoursOpen",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                _vm._l(_vm.timeOptions, function(
                                  option,
                                  index
                                ) {
                                  return _c(
                                    "option",
                                    {
                                      key: index,
                                      domProps: { value: option.value }
                                    },
                                    [_vm._v(" " + _vm._s(option.text) + " ")]
                                  )
                                }),
                                0
                              ),
                              _c("div", {
                                staticClass: "w-6  border border-gray-200 mx-2"
                              }),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: officeHour.officeHoursClosed,
                                      expression: "officeHour.officeHoursClosed"
                                    }
                                  ],
                                  staticClass:
                                    "mt-1 block  py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm",
                                  staticStyle: { color: "#22292f" },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        officeHour,
                                        "officeHoursClosed",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                _vm._l(_vm.timeOptions, function(
                                  option,
                                  index
                                ) {
                                  return _c(
                                    "option",
                                    {
                                      key: index,
                                      domProps: { value: option.value }
                                    },
                                    [_vm._v(" " + _vm._s(option.text) + " ")]
                                  )
                                }),
                                0
                              ),
                              _c(
                                "label",
                                { staticClass: "text-gray-500 ml-4 text-sm" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: officeHour.officeClosed,
                                        expression: "officeHour.officeClosed"
                                      }
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(
                                        officeHour.officeClosed
                                      )
                                        ? _vm._i(
                                            officeHour.officeClosed,
                                            null
                                          ) > -1
                                        : officeHour.officeClosed
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$a = officeHour.officeClosed,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                officeHour,
                                                "officeClosed",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                officeHour,
                                                "officeClosed",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            officeHour,
                                            "officeClosed",
                                            $$c
                                          )
                                        }
                                      }
                                    }
                                  }),
                                  _vm._v(" Office Closed ")
                                ]
                              )
                            ])
                          ])
                        }),
                        0
                      )
                    ])
                  ])
                : _vm._e(),
              _c("div", { staticClass: "mt-8 border-t border-gray-200 pt-5" }, [
                _c("div", { staticClass: "flex justify-end" }, [
                  _c(
                    "span",
                    { staticClass: "ml-3 inline-flex rounded-md shadow-sm" },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "Polaris-Button Polaris-Button--primary",
                          attrs: { type: "submit" },
                          on: { click: _vm.updateOfficeHours }
                        },
                        [_vm._m(1)]
                      )
                    ]
                  )
                ])
              ])
            ],
            1
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "md:col-span-1" }, [
      _c("h3", { staticClass: "text-lg font-medium leading-6 text-gray-900" }, [
        _vm._v(" Office Hours ")
      ]),
      _c("p", { staticClass: "mt-1 text-sm leading-5 text-gray-500" }, [
        _vm._v(
          " Set office hours for your agents. If the customer visits your website outside of your office hours we wont show the contact button. "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "Polaris-Button__Content" }, [
      _c("span", { staticClass: "Polaris-Button__Text" }, [_vm._v("Save")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }